export default __webpack_public_path__ + "images/87ab47aab635d82035f26efd6850a54d.svg";